<div class="row">
  <div class="col-12 col-md-12 col-lg-8">
    <div class="mb-3">
      <label for="requestPurpose" class="form-label">
        {{ label }}
        <span
          *ngIf="controlIsRequired('RequestPurpose') && label"
          class="color-error"
          >*</span
        >
      </label>
      <textarea
        class="form-control"
        [formControl]="getFormControl('RequestPurpose')"
        id="requestPurpose"
        [placeholder]="!label ? 'Purpose of loan' : ''"
        rows="3"
        aria-label="Purpose of loan"
        [maxlength]="500"
      ></textarea>
    </div>
  </div>
</div>
